var _desc, _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgExpand(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "-1.095 -1.095 35 35",
    height: 35,
    width: 35,
    id: "Expand-Full--Streamline-Ultimate.svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Expand Full Streamline Icon: https://streamlinehq.com")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M1.0253124999999998 11.275771687499997v-8.202499999999999c0 -0.5438667625 0.21604701458333334 -1.0654500666666666 0.6006143916666666 -1.450010608333333C2.010487433333333 1.2386896008333332 2.532084408333333 1.02264258625 3.0759374999999998 1.02264258625h8.202499999999999",
    strokeWidth: 2.19
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M31.784687499999997 11.275771687499997v-8.202499999999999c0 -0.5438667625 -0.21599916666666666 -1.0654500666666666 -0.6005597083333333 -1.450010608333333 -0.38456054166666664 -0.3845714783333333 -0.9062395416666666 -0.6006184929166666 -1.4500652916666665 -0.6006184929166666h-8.202499999999999",
    strokeWidth: 2.19
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M1.0253124999999998 21.52882833333333v8.202499999999999c0 0.5439624583333332 0.21604701458333334 1.06550475 0.6006143916666666 1.4500652916666665 0.38456054166666664 0.38456054166666664 0.9061575166666666 0.6005597083333333 1.450010608333333 0.6005597083333333h8.202499999999999",
    strokeWidth: 2.19
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M31.784687499999997 21.52882833333333v8.202499999999999c0 0.5439624583333332 -0.21599916666666666 1.06550475 -0.6005597083333333 1.4500652916666665s-0.9062395416666666 0.6005597083333333 -1.4500652916666665 0.6005597083333333h-8.202499999999999",
    strokeWidth: 2.19
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M7.1771875 7.1745216874999995h18.455624999999998V25.630078333333334H7.1771875V7.1745216874999995Z",
    strokeWidth: 2.19
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpand);
export default __webpack_public_path__ + "static/media/Expand.34ec2dd8146afa0b6f16fa1e58459060.svg";
export { ForwardRef as ReactComponent };